import Cookies from 'js-cookie'

$(function () {
  $('.js-accept-cookies').on('click', function () {
    Cookies.set('accept_cookies', 'ok', { expires: 30, path: '/' })
    $(this).closest('.cookie-message').slideUp()
    return false
  })

  $('.js-cancel-cookies').on('click', function () {
    $(this).closest('.cookie-message').slideUp()
    return false
  })
})
